import React from "react";
import AdminDisabledField from "features/Admin/components/AdminDisabledField";

const TakingForm = ({ values }) => (
	<div>
		<AdminDisabledField title="Urgent" value={values.urgent} />
		<AdminDisabledField title="Régime alimentaire spécifique" value={values.special_diet} />
		{values.special_diet && <AdminDisabledField title="Régime" value={values.diet} />}
		<AdminDisabledField title="Interdit à domicile" value={values.home_prohibited} />
		<AdminDisabledField title="Déconseillé à domicile" value={values.home_not_recommended} />
		<AdminDisabledField title="À jeun" value={values.fasting} />
		<AdminDisabledField title="À l'abri de la lumière" value={values.light_protected} />
		<AdminDisabledField title="Formulaire de consentement requis" value={values.required_consent} />
		<AdminDisabledField title="Note pour prélèvement" value={values.taking_note} isLongText={true} />
	</div>
);

export default TakingForm;
